import React from 'react';
import { clsx } from 'js/utils/classNames.util';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import '../../FormFields.scss';
import style from './FormErrorMessage.scss';

export const FormErrorMessage: React.FC<Types.IFormErrorMessageProps> = ({
    message,
    children,
    className = ''
}) => {
    const translate = useTranslations();

    return (
        <div className={clsx([style.errorMessage, className])}>
            {message && translate(message)}
            {children}
        </div>
    );
};
